import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { Play } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';

export const actionsRouteRef = createRouteRef();
export const workflowWizardRouteRef = createRouteRef({
  params: ['namespace', 'workflowName'],
});
export const runDetailRouteRef = createRouteRef({ params: ['taskId'] });

export const actionsPage = PageBlueprint.make({
  params: {
    path: '/actions',
    title: 'Actions',
    icon: <Play size={20} strokeWidth={2} />,
    routeRef: actionsRouteRef,
    noHeader: true,
    loader: () =>
      import('./ActionsPage').then(m => (
        <PageShareTitle title="Actions">
          <m.ActionsPage />
        </PageShareTitle>
      )),
  },
});

/** The workflow scaffolder wizard, kept under /actions — no stock Create chrome. */
export const workflowWizardPage = PageBlueprint.make({
  name: 'wizard',
  params: {
    path: '/actions/run/:namespace/:workflowName',
    routeRef: workflowWizardRouteRef,
    noHeader: true,
    loader: () =>
      import('./WorkflowWizardPage').then(m => <m.WorkflowWizardPage />),
  },
});

/** Regask run-detail page (replaces the stock scaffolder task page). */
export const runDetailPage = PageBlueprint.make({
  name: 'run-detail',
  params: {
    path: '/actions/runs/:taskId',
    routeRef: runDetailRouteRef,
    noHeader: true,
    loader: () => import('./RunDetailPage').then(m => <m.RunDetailPage />),
  },
});

export const actionsPlugin = createFrontendPlugin({
  pluginId: 'actions',
  extensions: [actionsPage, workflowWizardPage, runDetailPage],
});
